import { createApp } from 'vue'
import App from './App.vue'
import router from './router' 
import axios from '@/axios'
import md5 from 'js-md5'
import moment from 'moment'
import { List,PullRefresh  } from 'vant';
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
moment.locale('zh-cn')
let app = createApp(App)
app.config.globalProperties.$http = axios
app.config.globalProperties.$md5 = md5;
app.config.globalProperties.$moment = moment
import { Toast  } from 'vant';
// import Vconsole from 'vconsole'
//  new Vconsole()

app.use(router).use(Toast).use(List).use(PullRefresh).use(ElementPlus).mount('#app')
